export const baseApiUrl = function() {
    let baseUrl = '';

    if (process.env.NODE_ENV == 'staging') {
        baseUrl = 'https://stage-api.spindlplatform.com/';
    } else if (process.env.NODE_ENV == 'production') {
        //baseUrl = 'https://api.spindlplatform.com/';
        baseUrl = 'https://stage-api.spindlplatform.com/';
    } else if (process.env.NODE_ENV == 'dev') {
        baseUrl = 'http://localhost:8080/';
    } else {
        // baseUrl = 'http://localhost:8080/';
        // baseUrl = 'https://api.spindlplatform.com/';
        baseUrl = 'https://stage-api.spindlplatform.com/';
    }
    return baseUrl;
};



// WEBPACK FOOTER //
// ./src/config.js